import firebase from 'firebase/app'
import 'firebase/messaging'
import { firebaseConfig, vapidKey } from './firebase-config';
import {logger} from "./main";

var messaging = null;
var userData = null;

if (firebase.messaging.isSupported()) {
    firebase.initializeApp(firebaseConfig);

    messaging = firebase.messaging();

    // Add the public key generated from the console here.
    messaging.usePublicVapidKey(vapidKey);

    if (process.env.VUE_APP_PUSH_URL != null && process.env.VUE_APP_PUSH_URL.length > 0 && 'serviceWorker' in navigator) {
        navigator.serviceWorker.register(process.env.BASE_URL + 'firebase-messaging-sw.js', { scope: "/" }).then(function(reg) {
            // Registrierung erfolgreich
            logger.log('Messaging service worker registration successful. Scope is ' + reg.scope);

            messaging.useServiceWorker(reg);

        }).catch(function(error) {
            // Registrierung fehlgeschlagen
            logger.log('Registrierung fehlgeschlagen mit ' + error);
        });
        navigator.serviceWorker.ready.then(function(registration) {
            logger.log("service worker ready");
            if (userData) {
                setUserData(userData);
            }
        });
    }
}

function setUserData(data) {
    if ('serviceWorker' in navigator) {
        if (navigator.serviceWorker.controller) {
            logger.log('sending user data: ' + JSON.stringify(data));
            navigator.serviceWorker.controller.postMessage( { cmd: 'user', data: data} );
        } else {
            userData = data;
        }
    } else {
        // console.log('service worker not available');
    }

}

export {
    messaging,
    setUserData
}
